<template>
  <div id="modemSearch">
    <div class="bg">
      <div class="tit">모뎀 검색</div>
      <div class="desc">검색을 희망하는 모뎀의 전화번호로<br>모뎀 정보를 확인할 수 있습니다.</div>
      <div class="box">
        <div class="input_wrap">
          <input type="text" v-model="searchKeyword" @keyup.enter="search" placeholder="모뎀 전화번호"/>
        </div>
        <div class="btn_search" @click="search">검색</div>
      </div>
      <div class="notice">검색예시 : 010-222-3333, 0112223333 모두 가능</div>
    </div>
  </div>
</template>

<script>
import common from '../../script/common'
import modemInfo from '../../script/modemInfo'

export default {
  data () {
    return {
      // Common
      mySession: {},
      // Search
      searchKeyword: ''
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  methods: {
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    search () {
      this.filter = {
        page: 1,
        size: 1
      }
      delete this.filter['mobileNum']
      if (this.searchKeyword != null && this.searchKeyword.length > 0) {
        this.filter.mobileNum = this.searchKeyword.replaceAll('-', '')
      }
      this.updateList()
    },
    updateList () {
      modemInfo.getModemInfo(this.filter, response => {
        console.log('무선모뎀 검색', response)
        if (response.data.resultCode === 1) {
          const list = response.data.result.body.list
          if (list == null || list.length <= 0) {
            common.amsAlert('retry', '검색결과가 없습니다.')
            return
          }
          this.$router.push({
            name: 'ModemView',
            params: {
              data: list[0]
            }
          })
        } else {
          common.amsAlert('retry', '모뎀 정보를 불러오지 못했습니다.')
          this.list = []
        }
      })
    }
  }
}
</script>

<style scoped>
#modemSearch {
  width: 100%;
  height: calc(100vh - 60px);
}

#modemSearch .bg {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #F8F8FD url('../../assets/mobile/m_bg.png') right bottom no-repeat;
}

#modemSearch .bg > .tit {
  margin-top: 40px;
  color: #25324B;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.1;
}

#modemSearch .bg > .desc {
  margin-top: 16px;
  color: #515B6F;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
}

#modemSearch .bg > .box {
  display: flex;
  width: calc(100% - 32px);
  padding: 16px;
  margin: 24px 16px 0;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 18px;
  background: #FFF;
  box-shadow: 0px 4px 4px 0px rgba(192, 192, 192, 0.03), 0px 7px 11px 0px rgba(192, 192, 192, 0.04), 0px 14px 23px 0px rgba(192, 192, 192, 0.05), 0px 29px 47px 0px rgba(192, 192, 192, 0.06), 0px 79px 128px 0px rgba(192, 192, 192, 0.09);
}

#modemSearch .bg > .box > .input_wrap {
  width: 100%;
  height: 27px;
  padding-left: 48px;
  box-sizing: border-box;
  background: url('../../assets/mobile/m_ic_search.svg') 8px center no-repeat;
}

#modemSearch .bg > .box > .input_wrap > input {
  width: 100%;
  height: 27px;
  padding: 0;
  border: none;
  border-bottom: 1px solid #D6DDEB;
  border-radius: 0;
  font-size: 16px;
}

#modemSearch .bg > .box > .btn_search {
  display: flex;
  height: 57px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  background: #3E7EFF;
  color: #FFF;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.6;
}

#modemSearch .bg > .notice {
  padding: 0 16px;
  margin-top: 10px;
  opacity: 0.7;
  color: #25324B;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/ModemSearch.vue